import { getMinAmount, getUrlDashboard } from '../../../network/api/project';
import { getAmountRegister } from '../../../network/api/invoicing';
import type { AppDispatch, RootState } from 'services/store/types';
import { logError } from 'utils/logs';

export function getConfig() {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      dispatch({
        type: 'UPDATE_STATUS',
        payload: 'INPROGRESS',
      });
      let projectId = getState().user.projectId;
      if (projectId === 0) {
        projectId = parseInt(JSON.parse(localStorage.getItem('ayomi_project') || '{}')?.projectId || '0');
      }
      if (projectId === 0) {
        projectId = parseInt(new URLSearchParams(window.location.search).get('idAyomi') || '0');
      }
      const { data: dataUrl } = await getUrlDashboard(projectId);
      const { data: minAmount } = await getMinAmount();
      const { data: dataRegister } = await getAmountRegister();
      dispatch({
        type: 'FETCH_CONFIG_DATA',
        payload: {
          calendly: `https://vc${process.env.REACT_APP_DEBUG ? '-dev' : ''}.ayomi.fr?utm_source=home-9`,
          contractor: dataUrl.url,
          minAmount: parseFloat(minAmount?.value || 20000),
          amountRegistration: dataRegister?.amount || 5000,
        },
      });
    } catch (err) {
      logError(err as Error);
      dispatch({
        type: 'UPDATE_STATUS',
        payload: 'ERROR',
      });
      console.log(err);
    }
  };
}
